import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import TicketList from "./containers/TicketList/TicketList";
import RagData from "./containers/RagData/RagData";
import Scheduler from "./containers/Scheduler/Scheduler";
import Buckets from "./containers/Buckets/Buckets";
import GChat from "./containers/GChat/GChat";
import GChatBuckets from "./containers/GChatBuckets/GChatBuckets";
import GChatConversations from "./containers/GChatConversations/GChatConversations";
import PreventiveActions from "./containers/PreventiveActions/PreventiveActions";
import RcaScheduler from "./containers/RcaScheduler/RcaScheduler";
import MetricsDashboard from "./containers/MetricsDashboard/MetricsDashboard";
import DailyDipstick from "./containers/DailyDipstick/DailyDipstick";
import ApiKeys from "./containers/ApiKeys/ApiKeys";
import PromptManager from "./containers/PromptManager/PromptManager";
import Login from "./components/Login/Login";

const PrivateRoute = ({ element }) => {
  if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_GOOGLE_CLIENT_ID) {
    return element;
  }
  const token = localStorage.getItem("authToken");
  if (!token) {
    return <Navigate to="/login" />;
  }
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      return <Navigate to="/login" />;
    }
  } catch {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    return <Navigate to="/login" />;
  }
  return element;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute element={<TicketList />} />} />
        <Route path="/rag" element={<PrivateRoute element={<RagData />} />} />
        <Route path="/scheduler" element={<PrivateRoute element={<Scheduler />} />} />
        <Route path="/buckets" element={<PrivateRoute element={<Buckets />} />} />
        <Route path="/gchat" element={<PrivateRoute element={<GChat />} />} />
        <Route path="/gchat/buckets" element={<PrivateRoute element={<GChatBuckets />} />} />
        <Route path="/gchat/conversations" element={<PrivateRoute element={<GChatConversations />} />} />
        <Route path="/gchat/preventive-actions" element={<PrivateRoute element={<PreventiveActions />} />} />
        <Route path="/rca-scheduler" element={<PrivateRoute element={<RcaScheduler />} />} />
        <Route path="/metrics" element={<PrivateRoute element={<MetricsDashboard />} />} />
        <Route path="/daily-dipstick" element={<PrivateRoute element={<DailyDipstick />} />} />
        <Route path="/api-keys" element={<PrivateRoute element={<ApiKeys />} />} />
        <Route path="/prompts" element={<PrivateRoute element={<PromptManager />} />} />
      </Routes>
    </Router>
  );
};

export default App;
